import { render, staticRenderFns } from "./commentsItems.vue?vue&type=template&id=98bf96bc&"
import script from "./commentsItems.vue?vue&type=script&lang=js&"
export * from "./commentsItems.vue?vue&type=script&lang=js&"
import style0 from "./commentsItems.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports